import { useAuthorizedUser } from 'Services/User/useAuthorizedUser';
import { ARTICLE, NEWS } from 'Constants/articleTypes';

import type { ArticleTypeT } from 'Constants/articleTypes';

const HEADER_TRAY_TYPES = new Set([ARTICLE, NEWS]);

export const useShowHeaderTray = (contentType: ArticleTypeT | null) => {
  const { isAnyProSubscriber } = useAuthorizedUser();

  return Boolean(
    contentType && isAnyProSubscriber && HEADER_TRAY_TYPES.has(contentType),
  );
};
